import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-healthstatus',
    templateUrl: './healthstatus.component.html',
    styleUrls: ['./healthstatus.component.css'],
    standalone: false
})
export class HealthstatusComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
